module.exports = __webpack_public_path__ + "img/tg.951484b4.svg";